<template>
  <div>
    <loader :loading="loading" />
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Nbr page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
            </b-form-group>
          </b-col>

          <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Année</label>
              <b-form-select id="perPageSelect" v-model="currentYear" size="sm" :options="years"
                             class="w-50" />

            </b-form-group>
          </b-col>


          <b-col md="4" sm="4" class="my-1">
            <b-form-group
                label="Status"
                label-cols-sm="3" label-align-sm="right" label-size="sm" class="mb-0"
            >
              <v-select
                  v-model="selectedStatus"
                  multiple
                  label="label"
                  :options="optionStatus"
                  class="flex-grow-1"
              />
            </b-form-group>
          </b-col>


          <b-col md="4" class="my-1">
            <b-form-group label="Filtrer" label-cols-sm="3" label-align-sm="right" label-size="sm"
                          label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher..." @input="fetchUserWithEvaluationDTO" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
<!--          <b-col cols="12">-->
<!--            <div class="demo-inline-spacing d-flex mb-1">-->





<!--            </div>-->
<!--          </b-col>-->
<!--          :per-page="perPage"  :current-page="currentPage"  :filter="filter"
                :filter-included-fields="filterOn"-->

          <b-col cols="12">
            <b-table
                striped hover responsive

                :items="userWithEvaluationDTO"
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"

                @filtered="onFiltered"
            >

              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar
                        size="40"
                        variant="light-primary"
                        class="badge-minimal"
                        badge-variant="success"
                    >
                      {{ getUserInitials(data.item) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.lastName }} {{ data.item.firstName }}
                  </span>
                  <small class="text-muted">{{ data.item.fonction }}</small>
                </b-media>
              </template>

              <!-- Colonne Fonction -->
              <template #cell(fonction)="data">
                <span class="font-weight-bold d-block text-nowrap">{{ data.item.fonction }}</span>
                <small class="text-muted" v-if="data.item.service">{{ data.item.service }}</small>
              </template>

              <!-- Colonne Statut -->
              <template #cell(status)="data">
                <b-badge :variant="statusVariants[data.item.status || 'TO_EVALUATE']">
                  {{ statusLabels[data.item.status || 'TO_EVALUATE'] }}
                </b-badge>
              </template>

              <!-- Colonne Prochaine étape -->
              <template #cell(nextStep)="data">
                <span class="text-primary">{{ nextStepLabels[data.item.status] }}</span>
              </template>

              <!-- Colonne Actions -->
              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <!-- Vue détail -->
                  <feather-icon
                      v-if="data.item.status !== null && data.item.status !== 'SELF_EVALUATION' && data.item.status !== 'INPROGRESS'"
                      :id="`evaluation_print-row-${data.item.userEvaluationIdPublic ? data.item.userEvaluationIdPublic: data.item.userId}-preview-icon`"
                      icon="EyeIcon"
                      size="16"
                      class="mx-1"
                      @click="formEvaluation(data.item)"

                  />
                  <b-tooltip
                      title="Détail Évaluation"
                      :target="`evaluation_print-row-${data.item.userEvaluationIdPublic ? data.item.userEvaluationIdPublic: data.item.userId}-preview-icon`"
                  />
                  <!-- Icône Modifier -->
                  <feather-icon
                      v-if="showUpdateButton(data.item)"
                      :id="`evaluation-edit-row-${data.item.userEvaluationIdPublic || data.item.userId}-icon`"
                      icon="EditIcon"
                      size="16"
                      class="mx-1"
                      @click="editEvaluation(data.item)"
                  />
                  <b-tooltip
                      title="Éditer l'évaluation"
                      :target="`evaluation-edit-row-${data.item.userEvaluationIdPublic || data.item.userId}-icon`"
                  />

                  <!-- Icône Planifier -->
                  <feather-icon
                      v-if="canChangeDateEvaluation(data.item)"
                      :id="`evaluation-schedule-row-${data.item.userEvaluationIdPublic || data.item.userId}-icon`"
                      icon="CalendarIcon"
                      size="16"
                      class="mx-1"
                      @click="scheduleEvaluation(data.item)"
                  />
                  <b-tooltip
                      title="Définir la date de validation"
                      :target="`evaluation-schedule-row-${data.item.userEvaluationIdPublic || data.item.userId}-icon`"
                  />

                </div>
              </template>
            </b-table>
          </b-col>


        </b-row>
      </b-card-body>
      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm" class="my-1" />
      </b-col>

    </b-card>


    <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="OK" centered size="sm"
             :title="'Date'" @ok="confirmDateEvaluation">
      <b-row>
        <b-col md="12">
          <b-form-group>
            <h5>Date prévue pour le rendez-vous d'évaluation</h5>
            <!-- <flat-pickr v-model="inlineDate" class="form-control"
                :config="{ enableTime: true, dateFormat: 'd-m-y H:i' }" /> -->
            <flat-pickr v-model="inlineDate" class="form-control" :config="flatPickrConfig" />

          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>


<script>
import {
  BTable,
  BAvatar,
  // BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton
} from 'bootstrap-vue'
import {
  getUserEvaluationsAll,
  updateDateEvaluationMeeting
} from '@/services/UserEvaluationService';
import { getSetting } from '@/services/SettingService';
// import { getAllConfigs } from '@/services/EvaluationIntervalConfigsService';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getJsonFromStorage } from "@/util/storageUtils";
import flatPickr from 'vue-flatpickr-component';
import { allYears } from '@/services/YearsService';
import vSelect from 'vue-select'
import {French} from "flatpickr/dist/l10n/fr";
import Loader from "@/layouts/components/Loader.vue";
import moment from "moment/moment";

import {getConfigs} from "@/services/EvaluationIntervalConfigsService";


export default {
  components: {
    Loader,
    BTable,
    BAvatar,
    // BBadge,
    BRow,
    BCol,
    // BFormGroup,
    // BFormSelect,
    BPagination,
    // BInputGroup,
    // BFormInput,
    // BInputGroupAppend,
    // BButton,
    vSelect,
    flatPickr,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      loading: false,
      perPage: 10,
      pageOptions: [3, 5, 10, 25, 50, 100, 200],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      userWithEvaluationDTO: [],
      isModalActive:false,
      inlineDate: null,
      userEvaluationsData:{},
      maxDateDays: null,
      currentYear: null,
      selectedStatus:[],
      years:[],
      evaluationStartDate:null,
      statusVariants: {
        INPROGRESS: "warning",
        TO_EVALUATE: "warning",
        SELF_EVALUATION: "warning",
        EVALUATION: "primary",
        TERMINATED: "warning",
        MEETING: "secondary",
        VALIDATED_BY_HIERARCHY: "success",
        TRANSMIT_HIERARCHY_2: "warning",
        APPROVED: "success",
        VALIDATED_BY_COLLABORATOR: "success",
        REJECTED: "danger",
      },
      nextStepLabels: {
        INPROGRESS: "Pré-Evaluation",
        TO_EVALUATE: "-",
        SELF_EVALUATION: "-",
        EVALUATION: "-",
        TERMINATED: "Attente de rendez-vous !",
        MEETING: "Validation par manager !",
        VALIDATED_BY_HIERARCHY: "Validation par collaborateur !",
        TRANSMIT_HIERARCHY_2: "Validation par manager N+2 !",
        APPROVED: "Validation par collaborateur !",
        VALIDATED_BY_COLLABORATOR: "-",
        REJECTED: "Correction par N+1 !"
      },
      statusLabels: {
        TO_EVALUATE: "À évaluer",
        INPROGRESS: "À évaluer",
        SELF_EVALUATION: "À évaluer",
        EVALUATION: "En cours d'évaluation ",
        TERMINATED:"En cours d'évaluation ",
        MEETING: "En cours d'évaluation ",
        VALIDATED_BY_HIERARCHY: "Validé par manager",
        TRANSMIT_HIERARCHY_2: "Transmis au manager N+2",
        APPROVED: "Approuvé",
        VALIDATED_BY_COLLABORATOR: "Validé par collaborateur",
        REJECTED: "Rejeté"
      },
      optionStatus: [
        { value: 'INPROGRESS', label: 'Auto Évaluation en cours' },
        { value: 'TO_EVALUATE', label: 'À évaluer' },
        { value: 'SELF_EVALUATION', label: 'Auto Évaluation' },
        { value: 'EVALUATION', label: 'Évaluation effectuée' },
        { value: 'TERMINATED', label: 'En attente de rendez-vous' },

        { value: 'MEETING', label: 'Rendez-vous pris' },
        { value: 'TRANSMIT_HIERARCHY_2', label: 'Transmis au manager N+2' },
        { value: 'VALIDATED_BY_HIERARCHY', label: 'Validé par manager' },
        { value: 'APPROVED', label: 'Approuvé' },
        { value: 'VALIDATED_BY_COLLABORATOR', label: 'Validé par collaborateur' },
        { value: 'REJECTED', label: 'Rejeté' }
      ],
      configs: [],
      evaluationDeadline: 0,
    }
  },
  computed: {
    French() {
      return French
    },
    tableColumns() {
      const columns = [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'nextStep', label: 'Prochaine étape', sortable: true },
        { key: 'actions', label: 'Actions' },
      ]
      if (this.userWithEvaluationDTO.services) {
        columns.push({ key: 'services', label: 'Services', sortable: true })
      }
      return columns
    },


    sortOptions() {
      return this.tableColumns.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }))
    },

    flatPickrConfig() {
      const today = new Date();

      let minDate = this.evaluationStartDate
          ? moment(this.evaluationStartDate, "DD-MM-YYYY").hour(8).minute(0).second(0).millisecond(0).toDate()
          : today;


      let daysToAdd = this.evaluationDeadline;

      let maxDate = this.addBusinessDays(minDate, daysToAdd);

      if (minDate < today) {
        minDate = today;
      }

      const MIN_BUSINESS_DAYS = 5;

      const datePropose = this.userEvaluationsData?.dateEvaluationPropose
          ? moment(this.userEvaluationsData.dateEvaluationPropose, "DD-MM-YYYY HH:mm").toDate()
          : this.userEvaluationsData?.dateEvaluationPrevu
              ? moment(this.userEvaluationsData.dateEvaluationPrevu, "DD-MM-YYYY HH:mm").toDate()
              : null;
      if (datePropose && datePropose < minDate) {
        minDate = today;
      }
      if (maxDate <= minDate) {
        maxDate = this.addBusinessDays(minDate, MIN_BUSINESS_DAYS);

      } else {
        const businessDaysLeft = this.countBusinessDays(minDate, maxDate);

        if (businessDaysLeft < MIN_BUSINESS_DAYS) {
          maxDate = this.addBusinessDays(maxDate, MIN_BUSINESS_DAYS);
        }
      }

      return {
        enableTime: true,
        time_24hr: true,
        enableSeconds: false,
        inline: true,
        altInput: true,
        altFormat: "d-m-Y H:i",
        dateFormat: "d-m-Y H:i",
        minDate: today,
        maxDate,
        locale: French,
        disable: [
          function(date) {
            const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            if (d.getDay() === 0 || d.getDay() === 6) {
              return true;
            }

            if (datePropose && moment(date).isSame(datePropose, 'minute')) {
              return false;
            }

            return d < t;
          }
        ]
      };
    }


  },


  watch: {
    perPage(newValue, oldValue) {
      this.fetchUserWithEvaluationDTO();
    },
    currentPage(newValue, oldValue) {
      this.fetchUserWithEvaluationDTO();
    },
    currentYear(newValue, oldValue) {
      this.fetchUserWithEvaluationDTO();
    },
    selectedStatus(newValue, oldValue) {
      this.fetchUserWithEvaluationDTO();
    },
    isModalActive(val) {
      if (!val) {
        this.inlineDate = null;
        this.userEvaluationsData = {};
      }
    }
  },

  methods:{
    countBusinessDays(start, end) {
      let count = 0;
      const date = new Date(start);

      while (date < end) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) {
          count++;
        }
      }
      return count;
    },
    addBusinessDays(today, daysToAdd) {
      const date = new Date(today);
      let addedDays = 0;

      if (date.getDay() !== 0 && date.getDay() !== 6) {
        addedDays = 1;
      }

      while (addedDays < daysToAdd) {
        date.setDate(date.getDate() + 1);

        const day = date.getDay();
        if (day !== 0 && day !== 6) {
          addedDays++;
        }
      }

      return date;
    },
    showUpdateButton(item) {

      const dateStr =
          item.dateEvaluationPropose ||
          item.dateEvaluationPrevu;

      if (!dateStr) return true;

      const datePlan = moment(dateStr, 'DD-MM-YYYY HH:mm', true)
      const datePlanSubstract = this.getEvaluationDateWithHourSubstracted(dateStr)
      const isBetween = moment().isBetween(datePlanSubstract, datePlan)

      if (isBetween) return false;
      const isAfter = moment().isAfter(datePlan)

      // if (isAfter) {
      //   return !item.h2 &&
      //       item.status !== 'VALIDATED_BY_COLLABORATOR' &&
      //       item.status !== 'APPROVED';
      // }

      return !item.h2 &&
          item.status !== 'VALIDATED_BY_COLLABORATOR' &&
          item.status !== 'APPROVED';


    },
    async fetchConfigs() {
      try {

        const reponse = await getConfigs(this.userData.id);
        this.evaluationDeadline = reponse.intervalDays;
      } catch (error) {
        console.error('Erreur lors de la récupération des configs:', error);
      }
    },

    async fetchUserWithEvaluationDTO() {
      try {
        if (this.userData && this.currentYear) {

          const response = await getUserEvaluationsAll(this.currentPage - 1, this.perPage, this.userData.id,null, this.currentYear,this.filter,false)

          if (response) {

            this.userWithEvaluationDTO = response.userWithEvaluationDTO

            this.totalRows = response.count

          }
        }

      } catch (error) {
        console.error('Error fetching user evaluation:', error)
      }
    },

    async getAllYears() {
      const response = await allYears();
      this.years = response.map(item => item.year);

    },

    async fetchSetting() {
      const response = await getSetting();

      // console.log(response)

      if (response && response.yearEvaluation) {
        this.currentYear = response?.yearEvaluation?.year;
        this.evaluationStartDate = response.evaluationStartDate;
      }

    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getUserInitials(user) {
      const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : ''
      const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : ''
      return `${lastInitial}${firstInitial}`
    },

    editEvaluation(data) {
      this.userEvaluationsData.idPublic = data.userEvaluationIdPublic;
      if (data.userEvaluationIdPublic) {
        this.$router.push({ name: 'evaluation', query: { id: data.userEvaluationIdPublic, userId: null, year: this.currentYear } });
      } else {
        this.$router.push({ name: 'evaluation', query: { id: null, userId: data.userId, year: this.currentYear } });
      }
    },
    scheduleEvaluation(data) {
      this.userEvaluationsData = { ...data }; // clone to avoid mutation issues
      this.userEvaluationsData.idPublic = data.userEvaluationIdPublic;

      // Set the date for the picker
      this.inlineDate = data.dateEvaluationPrevu
          ? data.dateEvaluationPrevu
          : data.dateEvaluationPropose
              ? data.dateEvaluationPropose
              : moment().format('DD-MM-YYYY HH:mm');



      this.isModalActive = true;
    },

    confirmDateEvaluation() {
      if (!this.inlineDate) {
        this.showToast("Veuillez sélectionner une date.", "danger", 'AlertCircleIcon');
        return;
      }

      if (!this.userEvaluationsData.proposeDate || this.userEvaluationsData.proposeDate < 2) {

        // Mettre à jour userEvaluationsData
        if (this.userEvaluationsData.status==='MEETING' && this.userEvaluationsData.dateEvaluationPrevu) {
          this.userEvaluationsData.dateEvaluationPrevu = this.inlineDate;

        } else {
          this.userEvaluationsData.dateEvaluationPropose = this.inlineDate;

        }

        updateDateEvaluationMeeting(this.userEvaluationsData.idPublic, this.userEvaluationsData, 'MANAGER_PROPOSE')
            .then(result => {
              if (result.status === "MEETING") {

                // this.fetchUserEvaluationData(this.currentYear)

                this.showToast("Date prévue enregistrée avec succès", "success", "BellIcon");
              } else if (result.status === "EVALUATION" || result.status === "TERMINATED") {
                this.showToast("Date proposée enregistrée avec succès", "success", "BellIcon");
              }
              // else {
              //   this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
              // }
            })
            .catch(error => {
              this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
              console.error("Erreur lors de la récupération des données :", error);
            });
      } else {
        this.showToast("Nombre maximal de propositions atteint", "danger", "BellIcon");

      }

    },

    showToast (message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: icon,
          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },


    isHierarchyN2() {

      if (this.userEvaluationsData && this.userEvaluationsData.evaluationSignature) {

        const userEvaluationSignature = this.userEvaluationsData.evaluationSignature.find(sigObj => sigObj.users.id === this.userData.id);
        return userEvaluationSignature && userEvaluationSignature.hierarchyN === 2;


      }
    },
    formEvaluation(data) {
      this.$router.push({name: 'evaluation_prints', params: {id: data.userEvaluationIdPublic, isRapport: 0}});

      // if ( data.status === 'EVALUATION' || data.status === 'SELF_EVALUATION' || data.status === 'TERMINATED' || (data.status === "MEETING" && !data.dateEvaluationPrevu) ) {
      //
      //   this.$router.push({ name: 'evaluation_print', params: { id: data.userEvaluationIdPublic } });
      //
      // } else {
      //
      //     const datePlan = moment(data.dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
      //     const datePlanSubstract = this.getEvaluationDateWithHourSubstracted(data.dateEvaluationPrevu)
      //
      //     const isCurrentDateBeetween = moment().isBetween(datePlanSubstract, datePlan);
      //
      //     // const isDatePlanSubstractBeforeCurrent = datePlanSubstract.isBefore(moment());
      //
      //
      //     if (isCurrentDateBeetween || moment().isAfter(datePlan)) {
      //
      //       this.$router.push({ name: 'all_evaluation_print', params: { id: data.userEvaluationIdPublic } });
      //
      //     } else {
      //
      //       this.$router.push({ name: 'evaluation_print', params: { id: data.userEvaluationIdPublic } });
      //
      //     }
      // }
    },

    canChangeDateEvaluation(data) {
      if ( data.proposeDate===2){
        return false
      }
      if ((data.status === 'EVALUATION' || data.status === 'TERMINATED' || (data.status === "MEETING" && !data.dateEvaluationPrevu))) {

        return true;
      }

      else if(data.dateEvaluationPrevu ) {
        const datePlan = moment(data.dateEvaluationPrevu, "DD-MM-YYYY HH:mm", true);
        const datePlanSubstract = this.getEvaluationDateWithHourSubstracted(data.dateEvaluationPrevu);

        if (data.status === 'EVALUATION' || data.status === 'TERMINATED' || (data.status === "MEETING" && datePlan && datePlanSubstract.isAfter(moment())) ) {

          return true;
        }
      }

      else {

        return false
      }

    },

    getEvaluationDateWithHourSubstracted(date) {
      if(!date) {
        this.showToast('La date de validation est manquante', 'danger', 'danger');
        return;
      }

      const currentDate = moment(date, "DD-MM-YYYY HH:mm", true);

      return  currentDate.subtract(36, 'hours');
    },
  },
  async mounted() {
    this.userData = getJsonFromStorage('userData')

    await this.getAllYears()
    await this.fetchSetting()

    await this.fetchConfigs()

    await this.fetchUserWithEvaluationDTO()
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>
